import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
    Container,
    Paper,
    TextField,
    Button,
    Typography,
    Box,
    Alert, InputAdornment, IconButton
} from '@mui/material';
import {AdminPanelSettings, Visibility, VisibilityOff} from '@mui/icons-material';

const LoginAdmin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(email, password, true);
    
    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Paper elevation={12} sx={{ p: 4, width: '100%' }}>
          <Box textAlign="center" mb={4}>
            <AdminPanelSettings sx={{ fontSize: 60, color: 'secondary.main', mb: 2 }} />
            <Typography variant="h4" component="h1" gutterBottom>
              Administration
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Espace réservé
            </Typography>
          </Box>

          {error && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email Admin"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              autoFocus
            />
              <TextField
                  fullWidth
                  label="Mot de passe"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  margin="normal"
                  required
                  InputProps={{
                      endAdornment: (
                          <InputAdornment position="end">
                              <IconButton
                                  onClick={() => setShowPassword(!showPassword)}
                                  edge="end"
                              >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                          </InputAdornment>
                      )
                  }}
              />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="secondary" 
              size="large"
              disabled={loading}
              sx={{ mt: 3, mb: 2, p: 1.5 }}
            >
              {loading ? 'Connexion...' : 'Accès Admin'}
            </Button>

          
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginAdmin;
